import React from 'react';
import { getTheme, Stack, Text, FontIcon } from '@fluentui/react';

interface StyledTagProps {
  tag?: string;
  traitCount?: number;
  icon?: string;
  className?: string;
  children?: any;
}

export const StyledTag: React.FunctionComponent<StyledTagProps> = (props: StyledTagProps): JSX.Element => {
  const { palette } = getTheme();
  const tagStyle: React.CSSProperties = {
    display: 'inline-block',
    fontWeight: 600,
    color: palette.black,
    backgroundColor: palette.neutralLight,
    borderRadius: 56
  };

  const textStyle: React.CSSProperties = {
    fontWeight: 600,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'block',
    whiteSpace: 'nowrap'
  };

  const cssClass = 'px-2 ' + (props.className || '');

  return (
    <Stack className={cssClass} style={tagStyle} horizontal>
      <Stack.Item align="center">
        {props.icon && (
          <Text variant="small" className="pr-2">
            <FontIcon iconName={props.icon} />
          </Text>
        )}
      </Stack.Item>
      <Stack.Item align="center">
        {props.tag != null && (
          <Text variant="small" style={textStyle}>
            {props.tag}
          </Text>
        )}
        {props.traitCount !== undefined && props.traitCount > 0 && (
          <Text variant="small" style={textStyle}>
            +{props.traitCount}
          </Text>
        )}
        {props.children}
      </Stack.Item>
    </Stack>
  );
};
